import { useState } from 'react'
import {
  Column,
  DesktopModalWrapper,
  MobileModalWrapper,
  Row,
  Spacer,
  Text
} from '@smu-chile/pkg-unimarc-components'
import {
  getBemId,
  getGlobalStyle
} from '@smu-chile/pkg-unimarc-components/helpers'
import {
  patchUserAlvi,
  useMobile,
  useUserAlvi
} from '@smu-chile/pkg-unimarc-hooks'
import { ToastWrapper } from 'components/ToastWrapper'

export const TermsAndConditionsModal = () => {
  const blockId = getBemId('modal', 'terms-and-conditions-modal')

  const [showError, setShowError] = useState({
    isOpen: false,
    message: '',
    errorCode: ''
  })
  const [isLoading, setIsLoading] = useState(false)

  const { isMobileV2 } = useMobile()
  const { data: user, refetch } = useUserAlvi() || {}

  const handleShowError = (props: typeof showError) => {
    setShowError((prev) => {
      return {
        ...prev,
        ...props
      }
    })
  }

  const handleOneClick = async () => {
    try {
      setIsLoading(true)
      const payload = {
        email: user?.email,
        signedTermsAndConditions: new Date().toLocaleString('en-CA', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
      }
      const userResponse = await patchUserAlvi(payload)
      if (userResponse?.status === 204) {
        await refetch()
      } else {
        handleShowError({
          isOpen: true,
          message:
            'No pudimos actualizar tus preferencias. Intenta nuevamente.',
          errorCode:
            userResponse?.data?.code ||
            userResponse?.status?.toString() ||
            userResponse?.statusText ||
            '500'
        })
      }
      setIsLoading(false)
    } catch {
      // eslint-disable-next-line no-console
      console.error('Error updating user terms and conditions')
    }
  }

  const renderBody = () => {
    return (
      <Column
        alignItems='center'
        height='100%'
        justifyContent='center'
        overflow='hidden'
        padding='0px'
        width='100%'
      >
        {showError?.isOpen && (
          <ToastWrapper
            containerProps={{
              position: 'absolute',
              zIndex: '80',
              top: '20'
            }}
            errorCode={showError?.errorCode || ''}
            left='0px'
            message={showError?.message || 'Error al actualizar la información'}
            onClose={() => {
              return handleShowError({
                isOpen: false,
                message: '',
                errorCode: ''
              })
            }}
            position='relative'
            success={!showError?.errorCode}
            width={isMobileV2 ? '343px' : '373px'}
          />
        )}

        {!isMobileV2 && <Spacer.Horizontal customSize={63} />}
        <Row
          alignItems='center'
          justifyContent='center'
          padding='4px 12px'
          width='100%'
        >
          <Text
            color='black'
            fontSize='xl'
            fontWeight='semibold'
            lineHeight='normal'
          >
            Actualizamos la información legal
          </Text>
        </Row>
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            width: isMobileV2 ? '400px' : '460px',
            padding: '8px 20px',
            justifyContent: 'center',
            alignContent: 'center'
          }}
        >
          <Text
            color='black'
            fontSize='base'
            lineHeight='normal'
            textAlign='center'
            type='span'
          >
            Para continuar comprando en Alvi, deberás&nbsp;
          </Text>
          <Text
            color='black'
            fontSize='base'
            lineHeight='normal'
            textAlign='center'
            type='span'
          >
            aceptar los &nbsp;
          </Text>
          <Text
            fontWeight='medium'
            type='span'
            underline='always'
          >
            <a
              href={`${process.env.NEXT_PUBLIC_HOMEURL}/static/terminos-condiciones`}
              rel='noopener noreferrer'
              target='_blank'
            >
              términos y condiciones
            </a>
          </Text>
          <Text
            color='black'
            fontSize='base'
            lineHeight='normal'
            textAlign='center'
            type='span'
          >
            &nbsp; y &nbsp;
          </Text>
          <Text
            fontWeight='medium'
            type='span'
            underline='always'
          >
            <a
              href={`${process.env.NEXT_PUBLIC_HOMEURL}/static/politica-privacidad-ecommerce`}
              rel='noreferrer noreferrer'
              target='_blank'
            >
              las políticas de privacidad.
            </a>
          </Text>
        </Row>
        {!isMobileV2 && <Spacer.Horizontal customSize={70} />}
      </Column>
    )
  }

  if (!isMobileV2) {
    return (
      <DesktopModalWrapper
        blockId={blockId}
        bodyChildrenProps={{
          padding: '0px',
          overflow: 'hidden'
        }}
        footerChildrenProps={{
          default: true,
          boxShadow: 'none',
          padding: '12px 16px',
          buttonDefaultProps: {
            fontWeight: getGlobalStyle('--font-weight-medium'),
            fontSize: getGlobalStyle('--font-size-md'),
            onClick: handleOneClick,
            isLoading: isLoading
          }
        }}
        hasHeader={false}
        hasfooter={true}
        headerCloseIcon={{
          default: false
        }}
        modalConfigsProps={{
          isOpen: true,
          minHeight: '281px',
          maxWidth: '500px'
        }}
      >
        {renderBody()}
      </DesktopModalWrapper>
    )
  }

  return (
    <MobileModalWrapper
      blockId={blockId}
      body={renderBody()}
      bodyContainerProps={{
        padding: '0px',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      buttonConfigsProps={{
        height: '40px',
        label: 'Aceptar',
        site: 'alvi',
        fontWeight: getGlobalStyle('--font-weight-medium'),
        isLoading: isLoading,
        background: getGlobalStyle('--color-base-black'),
        onClick: handleOneClick
      }}
      dragProps={{
        dontAllowDrag: true,
        draggButton: false
      }}
      footerContainerProps={{
        padding: '12px 16px'
      }}
      hasShadow={false}
      headerProps={{
        border: 'none'
      }}
      hideHeaderDivider={false}
      iconSize={20}
      isEnableButton
      isHiddenHeaderCloseButton={true}
      modalConfigsProps={{
        openAnimation: true,
        fullScreenSticky: true,
        hiddenX: true,
        isAutoHeight: false,
        isOpen: true,
        isWindowBlocked: true,
        marginFullScreen: '90px 0 0',
        minHeightFullScreen: '275px',
        maxHeightFullScreen: '275px',
        stickyBottom: true
      }}
    />
  )
}
